export function initSendPasswordRedirect(root: HTMLElement): void {
    const redirectUrl = root.dataset.redirectUrl ?? '';

    if (!redirectUrl) {
        return;
    }

    window.setTimeout(() => {
        window.location.href = redirectUrl;
    }, 5000);
}
